const updateAppVersionShown = (config, isShownWeb) => ({
  ...config,
  appVersion: {
    ...config.appVersion,
    isShownWeb
  }
});

export { updateAppVersionShown };
